"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _buttonEffect = require("../../utils/buttonEffect");
var _excluded = ["active", "disabled", "asToggle", "onClick", "bsStyle", "bsSize", "variant", "iconOnly", "multiline", "block", "className", "noRippleEffect", "children"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Button = function Button(props) {
  var active = props.active,
    disabled = props.disabled,
    asToggle = props.asToggle,
    onClick = props.onClick,
    bsStyle = props.bsStyle,
    bsSize = props.bsSize,
    variant = props.variant,
    iconOnly = props.iconOnly,
    multiline = props.multiline,
    block = props.block,
    className = props.className,
    noRippleEffect = props.noRippleEffect,
    children = props.children,
    remainingProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(active),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isToggled = _useState2[0],
    setIsToggled = _useState2[1];
  var btnRef = (0, _react.useRef)();

  // Update internal toggle state when used as controlled component
  // and outside toggle state changes
  (0, _react.useEffect)(function () {
    return setIsToggled(active);
  }, [active]);

  // Register a dedicated click event on the button to interrupt
  // the actual 'onClick' callback passed into the component from outside
  (0, _react.useEffect)(function () {
    if (noRippleEffect || !btnRef.current) {
      return;
    }
    var mouseListener = btnRef.current.addEventListener('mousedown', _buttonEffect.createButtonRipple, false);
    var touchListener = btnRef.current.addEventListener('touchstart', _buttonEffect.createButtonRipple, false);
    return function () {
      mouseListener && btnRef.current.removeEventListener('mousedown', _buttonEffect.createButtonRipple, false);
      touchListener && btnRef.current.removeEventListener('touchstart', _buttonEffect.createButtonRipple, false);
    };
  }, [btnRef.current, noRippleEffect]);

  // Intercept click handler only for toggle button to update
  // internal state and blur after click
  var handleClick = function handleClick() {
    var newIsToggled = !isToggled;
    setIsToggled(newIsToggled);
    btnRef.current && newIsToggled && btnRef.current.blur();
    onClick(isToggled);
  };
  var buttonClassNames = (0, _classnames["default"])('btn', "btn-".concat(bsStyle), variant === Button.VARIANT_LINK && 'btn-link', variant === Button.VARIANT_LINK_INLINE && 'btn-link btn-link-inline', variant === Button.VARIANT_OUTLINE && 'btn-outline', variant === Button.VARIANT_ACTION && 'btn-action', bsSize && "btn-".concat(bsSize), asToggle && 'btn-toggle', isToggled && 'active', iconOnly && 'btn-icon-only', disabled && 'disabled', multiline && 'btn-multiline', block && 'btn-block', 'btn-component', className);
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
    ref: btnRef,
    type: 'button'
  }, remainingProps, {
    className: buttonClassNames,
    onClick: asToggle ? handleClick : onClick
  }), children);
};

// Button styles
Button.DEFAULT = 'default';
Button.PRIMARY = 'primary';
Button.SECONDARY = 'secondary';
Button.INFO = 'info';
Button.WARNING = 'warning';
Button.DANGER = 'danger';
Button.SUCCESS = 'success';
Button.MUTED = 'muted';

// Button Type
Button.VARIANT_LINK = 'link';
Button.VARIANT_LINK_INLINE = 'link-inline';
Button.VARIANT_OUTLINE = 'outline';
Button.VARIANT_ACTION = 'action';

// Button Size
Button.XS = 'xs';
Button.SM = 'sm';
Button.MD = 'md';
Button.LG = 'lg';
Button.defaultProps = {
  active: false,
  disabled: false,
  asToggle: false,
  iconOnly: false,
  multiline: false,
  block: false,
  noRippleEffect: false,
  onClick: function onClick() {},
  className: '',
  bsStyle: 'default'
};
Button.propTypes = {
  active: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  asToggle: _propTypes["default"].bool,
  iconOnly: _propTypes["default"].bool,
  multiline: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  bsStyle: _propTypes["default"].oneOf([Button.DEFAULT, Button.PRIMARY, Button.SECONDARY, Button.INFO, Button.WARNING, Button.DANGER, Button.SUCCESS, Button.MUTED]),
  bsSize: _propTypes["default"].oneOf([Button.XS, Button.SM, Button.MD, Button.LG]),
  variant: _propTypes["default"].oneOf([Button.VARIANT_LINK, Button.VARIANT_LINK_INLINE, Button.VARIANT_OUTLINE, Button.VARIANT_ACTION]),
  noRippleEffect: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var _default = Button;
exports["default"] = _default;